import { useMemo } from "react";

function useSectionVisibility(storageKey, sections) {
    return useMemo(() => {
        try {
            const raw = localStorage.getItem(storageKey);
            const obj = raw ? JSON.parse(raw) : null;
            if (!obj) return Object.fromEntries(sections.map(s => [s.key, true]));
            const base = Object.fromEntries(sections.map(s => [s.key, true]));
            return { ...base, ...obj };
        } catch {
            return Object.fromEntries(sections.map(s => [s.key, true]));
        }
    }, [storageKey, sections]);
}

export default useSectionVisibility;